import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { catchError, debounceTime, fromEvent, map } from "rxjs";
import { PagedResult } from "src/app/admin/models/common/pagination";
import {
  CreateUpdateReasonModel,
  ReasonModel,
  SearchReasonInputDto,
} from "src/app/admin/models/reason-model";
import { ReasonService } from "src/app/admin/services/reason.service";
import { BaseComponent } from "src/app/shared/base/base-component";
import { CreateEditReasonComponent } from "../create-edit-reason/create-edit-reason.component";

@Component({
  selector: "app-reason-tab",
  templateUrl: "./reason-tab.component.html",
  styleUrls: ["./reason-tab.component.scss"],
})
export class ReasonTabComponent
  extends BaseComponent
  implements OnInit, OnDestroy {
  filterInputFocus: boolean = false;
  public pageSize: number = 10;
  @ViewChild("inputRef", { static: true }) inputRef: ElementRef;
  @Input() gridView: PagedResult<ReasonModel>;
  @Input() showStatus: false;
  @Input() searchModel: SearchReasonInputDto;
  @Output() public reloadGrid: EventEmitter<SearchReasonInputDto> =
    new EventEmitter<SearchReasonInputDto>();
  constructor(
    private cd: ChangeDetectorRef,
    private reasonsService: ReasonService
  ) {
    super();
  }

  ngOnInit(): void {
    const input$ = fromEvent(this.inputRef.nativeElement, "input").pipe(
      debounceTime(1500)
    );
    input$.subscribe(() => {
      this.refresh(1);
    });
  }
  ngOnDestroy(): void {
    this.subscription.forEach((sb) => sb.unsubscribe());
  }
  refresh(page: number) {  
    this.searchModel.pageNumber = page;
    this.reloadGrid.emit(this.searchModel);
  }
  onFocus() {
    this.filterInputFocus = true;
    this.cd.detectChanges();
  }
  onBlur() {
    this.filterInputFocus = false;
    this.cd.detectChanges();
  }
  onPageSizechange() {
    this.searchModel.pageNumber = 1;
    this.searchModel.pageSize = this.pageSize;
    this.reloadGrid.emit(this.searchModel);
  }
  update(id: number): void {
    const sub = this.reasonsService
      .GetById(id)
      .pipe(
        map((response: CreateUpdateReasonModel) => {
          if (response) {
            const modalRef = this.modalService.open(CreateEditReasonComponent, {
              size: "xs",
            });
            modalRef.componentInstance.reason = response;
            modalRef.result.then(
              (res) => this.refresh(1),
              () => { }
            );
          }
        }),
        catchError((err) => {
          if (err.status === 403)
            this.translate
              .get(`CreateOrUpdateUser.${err.error.error.message}`)
              .subscribe((msg) => this.showErrorMessage(msg));
          else
            this.translate
              .get("ErrorCodes.RetrieveError")
              .subscribe((msg) => this.showErrorMessage(msg));
          return this.logException(err);
        })
      )
      .subscribe();
    this.subscription.push(sub);
  }
  deactivate(id: number): void {
    this.dialogService
      .confirm(
        "يرجى تأكيد التعطيل ..",
        "هل تريد تعطيل السبب؟",
        "تعطيل",
        "رجوع",
        "sm"
      )
      .then((confirmed) => {
        if (confirmed) {
          const subscrip = this.reasonsService.Dectivate(id).subscribe(() => {
            this.translate.get('Reasons.DeActivatedSuccessfully').subscribe(msg => this.showSuccessMessage(msg));
            this.refresh(1);
          }, error => {
            if (error.status == 403)
              this.translate.get(`Reason.${error.error.error.message}`).subscribe(msg => this.showErrorMessage(msg));
            else
              this.translate.get("ErrorCodes.RetrieveError").subscribe((msg) => this.showErrorMessage(msg));

            return this.logException(error);
          });
          this.subscription.push(subscrip);
          // const sub = this.userManagementService.Dectivate(id)
          //   .subscribe(() => {
          //     this.translate.get('CreateOrUpdateUser.DeactivatedSuccessfully').subscribe(msg => this.showSuccessMessage(msg));
          //     this.refresh(1);
          //   }, error => {
          //     this.submitted = false;
          //     if (error.status === 403)
          //       this.translate.get(`CreateOrUpdateUser.${error.error.error.message}`).subscribe(msg => this.showErrorMessage(msg));
          //     else
          //       this.translate.get('ErrorCodes.CreateError').subscribe(msg => this.showErrorMessage(msg));
          //     return this.logException(error);
          //   });
          // this.subscription.push(sub);
        }
      })
      .catch(() =>
        console.log(
          "User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)"
        )
      );
  }
}
